export default {"src":"/_next/static/media/eye-hide.04f473bb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};